import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import { createIcons, icons } from 'lucide';

window.bootstrap = bootstrap;

$(function () {
    $.fn.tooltip = (decorated => function (config) {
        if (typeof config === 'string') {
            return decorated.call(this, config);
        }

        config ??= {};

        return this.each(function () {
            const $element = $(this);
            const elementConfig = {...config};

            if ($element.is('.form-check[data-tooltips]')) {
                const tooltips = $element.data('tooltips');

                elementConfig.title = () => tooltips[$element.children('.form-check-input').prop('checked') ? 1 : 0];
            }

            decorated.call($element, elementConfig);
        });
    })($.fn.tooltip);

    $('[data-bs-toggle=tooltip]').tooltip();
});

$(document).on('show.bs.modal', function (event) {
    if (! event.relatedTarget) {
        return;
    }

    const $modal = $(event.target);
    const $button = $(event.relatedTarget);

    /*
     * Dynamic modals.
     *
     * Add data-dynamic-modal-src="<url>" to buttons to retrieve modal body via Ajax.
     */
    const dynamicModalSrc = $button.data('dynamicModalSrc');
    if (dynamicModalSrc) {
        $modal.find('.dynamic-modal-content').remove();

        let $placeholder = $modal.find('.dynamic-modal-placeholder');
        if ($placeholder.length) {
            $placeholder.show();
        } else {
            $placeholder = $('<div>', {class: 'dynamic-modal-placeholder'})
                .html('<div class="modal-body text-center"><span class="spinner-border" role="status"></span></div>')
                .appendTo($modal.find('.modal-content'));
        }

        let dynamicModalXhr = $modal.data('dynamicModalXhr');
        if (dynamicModalXhr) {
            dynamicModalXhr.abort();
        }

        dynamicModalXhr = $.get(dynamicModalSrc).done(function (response) {
            $placeholder.hide().after($('<div>', {class: 'dynamic-modal-content'}).html(response));
            createIcons({icons});
        });
        $modal.data('dynamicModalXhr', dynamicModalXhr);
    }

    /*
     * Automatically replace variables within modals.
     */
    const modalVars = $button.data('modalVars');
    if (modalVars) {
        $modal.data('$button', $button);
        $modal.find('[data-var]').each(function () {
            const $element = $(this);

            let variableAttrs = $element.data('var');
            if (typeof variableAttrs === 'string') {
                variableAttrs = {html: variableAttrs};
            }

            for (const attr in variableAttrs) {
                const value = modalVars[variableAttrs[attr]];

                if (attr === 'html') {
                    $element.html(value);
                } else if (attr === 'text') {
                    $element.text(value);
                } else if (attr.startsWith('data-')) {
                    $element.data(attr.substring(5), value)
                } else {
                    $element.attr(attr, value);
                }
            }
        });

        createIcons({icons});
    }
});
